module.exports = __webpack_public_path__ + "img/par05.24151ab9.png";